<template>
    <v-col cols="6" class="pt-3">
        <h4 class="font-weight-bold d-inline-block">
            {{ localModule.module.name }}
        </h4>
        <v-text-field
            v-model="localModule.add_amount"
            append-outer-icon="mdi-plus-circle-outline"
            prepend-icon="mdi-minus-circle-outline"
            type="number"
            @click:prepend="decrement"
            @click:append-outer="increment"
            @change="change"
            class="centered-input"
        ></v-text-field>
    </v-col>
</template>

<script>
import { getOptionalPrefillFromCustomer } from '@/shared/utils/moduleUtils'

export default {
    props: {
        module: {
            type: Object,
            require: true,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        fixedModules: {
            type: Array,
            default: () => [],
        },
        activeModuleIds: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            shouldChange: true,
            localModule: this.module,
        }
    },

    mounted() {
        if (
            this.isActive &&
            !this.localModule.skipActivePrefill &&
            this.activeModuleIds.length > 0
        ) {
            const prefill = getOptionalPrefillFromCustomer(
                this.activeModuleIds,
                this.localModule,
                this.fixedModules,
            )

            if (prefill && prefill.amount > 0) {
                this.shouldChange = false
                this.localModule.add_amount = prefill.amount
                this.$emit('addAmount', this.localModule)
                this.$nextTick(() => {
                    this.shouldChange = true
                })
            }
        }
    },

    methods: {
        decrement() {
            if (this.localModule.add_amount > 0) {
                this.localModule.add_amount--
                if (this.localModule.add_amount === 0) {
                    this.$set(this.localModule, 'skipActivePrefill', true)
                }
                this.$emit('addAmount', this.localModule)
            }
            this.shouldChange = true
        },
        increment() {
            if (
                this.maxAmount === -1 ||
                this.localModule.add_amount < this.maxAmount
            ) {
                this.localModule.add_amount++
                this.$set(this.localModule, 'skipActivePrefill', false)
                this.$emit('addAmount', this.localModule)
            }
            this.shouldChange = true
        },

        change(newValue) {
            if (
                this.shouldChange &&
                (this.maxAmount === -1 || newValue <= this.maxAmount)
            ) {
                this.localModule.add_amount = newValue
            } else {
                this.localModule.add_amount = this.maxAmount
            }

            if (this.localModule.add_amount <= 0) {
                this.$set(this.localModule, 'skipActivePrefill', true)
            } else {
                this.$set(this.localModule, 'skipActivePrefill', false)
            }

            this.$emit('addAmount', this.localModule)
            this.shouldChange = true
        },

        update(module) {
            this.localModule.checked = module.checked
            this.localModule.add_amount = module.add_amount
            this.shouldChange = false
        },
    },

    computed: {
        maxAmount() {
            return this.localModule.max_amount
        },
    },
}
</script>

<style>
.centered-input input {
    text-align: center !important;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type='number'] {
    -moz-appearance: textfield;
}
</style>
